import { render, staticRenderFns } from "./mLoader.vue?vue&type=template&id=5e09634b&scoped=true"
import script from "./mLoader.vue?vue&type=script&lang=ts"
export * from "./mLoader.vue?vue&type=script&lang=ts"
import style0 from "./mLoader.vue?vue&type=style&index=0&id=5e09634b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e09634b",
  null
  
)

export default component.exports